// @flow
import React, { Fragment, useState } from 'react';
import classnames from 'classnames';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { SocialPicture as InstagramPicture } from 'Components/frameworks/social-picture/SocialPicture';
import { Price } from 'Components/frameworks/price/Price';
import { ProductPriceModal } from 'Components/widgets/product-price-modal/ProductPriceModal';
import { t } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';

export type InstagramCardProps = {
  duration: null | string,
  href: null | string,
  id: string,
  index?: number,
  name: null | string,
  price: null | ProductPrice,
  socialPicture: SocialPicture,
  type: string,
};

export const InstagramCard = (props: InstagramCardProps) => {
  const { duration, href, id, index, name, price, socialPicture, type } = props;

  const [priceDetailIsDisplayed, setPriceDetailIsDisplayed] = useState(false);
  const track = useTracking({
    actionGA: 'push_content_instagram',
    labelGA: id,
  });

  const hasPrice = !!price && (!!price?.initialPrice || !!price?.bestPrice);

  const handleClick = (e: SyntheticEvent<*>) => {
    e.preventDefault(); // Prevent event from propagating to card link
    setPriceDetailIsDisplayed(!priceDetailIsDisplayed);
  };

  return (
    <div
      className={classnames('relative flex-none lg:flex-auto', {
        'rtl:ml-5': index !== 0,
      })}
      style={{ width: '60vw', maxWidth: '280px' }}
    >
      <DynamicLink
        url={href}
        className="block overflow-hidden relative"
        data-testid="instagram-card-link"
        onClick={() => track({})}
      >
        <InstagramPicture
          src={socialPicture.imageLarge}
          userName={socialPicture.userName}
          theme="cards"
        />
        <div className="absolute inset-x-0 top-1/2 bottom-0 p-3 sm:p-5 flex flex-wrap items-end content-end rounded-tiny overflow-hidden gradient-linear-transparent-black-80 text-white">
          <p className="m-0 truncate font-brand text-md sm:text-lg leading-normal">{name}</p>
          {hasPrice && (
            <Fragment>
              <Price
                onClick={handleClick}
                from={t('price.format.from')}
                bestPrice={price?.bestPrice}
                containerStyle={{}}
                style={{ minHeight: 'none' }}
                unit={price?.unit}
                theme="instagram"
              />
              <ProductPriceModal
                isVisible={priceDetailIsDisplayed}
                setIsVisible={setPriceDetailIsDisplayed}
                price={price}
                tourDuration={duration}
                type={type}
                onClick={() => {
                  setPriceDetailIsDisplayed(false);
                  track({});
                }}
              />
            </Fragment>
          )}
        </div>
      </DynamicLink>
    </div>
  );
};
